import { useRef, useState, useEffect } from 'react';
import type { FC, ReactNode } from 'react';
import { Box, Menu, ButtonBase } from '@mui/material';

interface BaseNavbarPopoverProps {
  children?: ReactNode;
  anchorEl?: ReactNode;
  isPopover?: boolean;
  title?: any;
  id?: string;
  isOpen?: boolean;
  onClose?: () => void;
}

const BaseNavbarPopover: FC<React.PropsWithChildren<BaseNavbarPopoverProps>> = (props) => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(false);
  }, [props.isOpen]);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  if (props.isPopover) {
    return (
      <>
        <ButtonBase title={props.title} onClick={handleOpen} ref={anchorRef} id={props.id} disableRipple>
          {props.anchorEl}
        </ButtonBase>

        <Menu
          anchorEl={anchorRef.current}
          anchorOrigin={{
            horizontal: 'left',
            vertical: 'bottom',
          }}
          keepMounted
          onClose={handleClose}
          open={open}
          className="global-nav__dropdown"
          onKeyDown={(e) => e.stopPropagation()}
          transitionDuration={0}
        >
          <Box className="global-nav__dropdown__items">{open && props.children}</Box>
        </Menu>
      </>
    );
  } else {
    return <>{props.children}</>;
  }
};

export default BaseNavbarPopover;
